module.exports = __webpack_public_path__ + "img/tablet.96bfecb4.svg";